/**
 * 页面布局相关
 */

import Layout from './Layout.vue';

export default Layout;